




































































import { Component, Prop, Watch, Inject, Vue } from "vue-property-decorator";
import InputSearch from "@/components/app/search/input-search.vue";
import ChangeDeliteButtons from "@/components/buttons/change-delite-buttons.vue";
import { deleteElement } from "@/api/delite/delite-element";
import { menu } from "@/config/host.config";

import { IBar } from "@/@types/menu/bars/bars";

@Component({
  components: {
    InputSearch,
    ChangeDeliteButtons,
  },
})
export default class RecuclerBarsList extends Vue {
  @Prop({ type: Array, default: [] }) barList!: IBar[];
  @Inject({ from: "barFolder", default: null }) readonly folder!: string;
  search = "";

  @Watch("search")
  filteredItems(): IBar[] {
    return this.barList.filter((item) => {
      if (item.name.length)
        return (
          this.$getLocale(item.name)
            .toLowerCase()
            .indexOf(this.search.toLowerCase()) > -1
        );
    });
  }

  changeElement(id: string): void {
    const url = menu.force;
    deleteElement(id, url)
      .then(() => {
        this.$emit("updateBarList");
      })
      .catch((e) => {
        console.log(e.message);
      });
  }
}
